import { dataProps } from './properties'

export const setCurrencyExchangeList = (state, payload) => {
    state.list = payload
}    

export const setCurrencyExchangeData = (state, payload) => {
    state.props = payload
} 

export const resetCurrencyExchangeData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/currencyExchange/mutations.js